import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { enterpriseLogsEnvironment } from '../enterprise-logs-environment';
import { copilotRequestPagedCollectionSchema } from '../schemas/copilot-request-paged-collection.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Requests CoPilot Logs in a paginated format
 * @param accountId Account ID
 * @param deviceId Device ID
 * @param operations An array of the specific operations you are requesting, null if none
 * @param onRoadEventTypes An array of the specific event types you are requesting, null if none
 * @param startTimestamp Start date/time of request
 * @param endTimestamp End date/time of request
 * @param offset Offset of paginated request
 * @param sorts Sorting parameters of request
 * @param size Number of logs being requested
 * @returns A paginated object containing an array of the requested logs
 */
export function postLogSearch(
  this: unknown,
  accountId: string,
  deviceId: string,
  operations: string[],
  onRoadEventTypes: string[],
  outOfRouteEventTypes: string[],
  startTimestamp: Date,
  endTimestamp: Date,
  offset: (number | string)[] | null,
  sorts: Record<string, unknown>[],
  size: number
) {
  const params = {
    deviceId,
    startTimestamp: startTimestamp.toJSON(),
    endTimestamp: endTimestamp.toJSON(),
    size,
    sort: sorts,
  };

  if (offset) {
    Object.assign(params, { offset });
  }

  if (operations.length > 0) {
    Object.assign(params, { operations });
  }

  if (onRoadEventTypes.length > 0) {
    Object.assign(params, { onRoadEventTypes });
  }

  if (outOfRouteEventTypes.length > 0) {
    Object.assign(params, { outOfRouteEventTypes });
  }

  const url = `${enterpriseLogsEnvironment
    .resolve(this)
    .logSearchUrl(accountId)}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(url, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(params),
      })
    )
  ).pipe(selectData(copilotRequestPagedCollectionSchema));
}
